import { Switch } from '@/components/elements/forms/Switch';
import Icon from '@/components/icons/Icon';
import { classnames } from '@/helpers/general';
import { _t } from '@/locale';
import { PickTimeViewBarProps } from './PickTimeViewBar.types';

/**
 * Bottom bar for the pick-time content views: the month-view toggle on the left
 * and the waitlist link on the right. Renders under the view's surface, not
 * inside it — it sets no background of its own. Desktop aligns it to the card's
 * edges, so the gutter is narrow's alone: there the bar runs to the screen edge
 * and has no surface to inherit one from.
 */
const PickTimeViewBar = ({
  monthViewOn = false,
  showWaitlist = false,
  isNarrow = false,
  onToggleMonthView,
  onOpenWaitlist,
}: PickTimeViewBarProps) => (
  <div className={classnames('h-4xl flex items-center justify-between', isNarrow && 'px-md')}>
    <div className="gap-xs flex items-center">
      {/* aria-hidden: the Switch already carries this text as its accessible name via `alt`. */}
      <span aria-hidden="true" className="text-fg_primary text-m">
        {_t('features.weekpicker.PickTimeCalendar.monthViewToggle')}
      </span>
      <Switch
        switched={monthViewOn}
        onChange={() => onToggleMonthView?.(!monthViewOn)}
        alt={_t('features.weekpicker.PickTimeCalendar.monthViewToggle')}
      />
    </div>
    {showWaitlist && (
      <button type="button" onClick={onOpenWaitlist} className="gap-2xs text-fg_link text-m flex items-center">
        <span className="underline">{_t('features.weekpicker.PickTimeCalendar.waitlist')}</span>
        <Icon variant="calendar-time" color="fg_link" size="sm" />
      </button>
    )}
  </div>
);

export default PickTimeViewBar;
